export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/sleep-tangerine.8751d74b530006d7d64194d2bb6c9716.png";